import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-api-map",
  "use": "icon-leo-api-map-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-api-map\">\r\n<g transform=\"translate(-113.571 -113.571) scale(1.221818)\">\r\n<path d=\"M160 448h224v128H160V448zm480 0h224v128H640V448z\" />\r\n  <path d=\"M352 496h320v32H352v-32z\" />\r\n  <path d=\"M448 288h128v160H448V288zm0 288h128v160H448V576z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-api-map.svg
// module id = eeWm
// module chunks = 491